import React, { createElement } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Meta Pixel
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}
;
(function (f: Window & typeof globalThis, b: Document, e: string, v: string, n?: any, t?: HTMLScriptElement, s?: Element) {
  if (f.fbq) return;
  n = f.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e) as HTMLScriptElement;
  t.async = true;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode!.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
window.fbq('init', '919507477136526');
window.fbq('track', 'PageView');
const container = document.getElementById('root')!;
createRoot(container).render(<React.StrictMode data-id="element-337">
    <App data-id="element-338" />
  </React.StrictMode>);